import script from "./ScreenVideoElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenVideoElement.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenVideoElement.vue?vue&type=style&index=0&id=76457308&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76457308"]])

export default __exports__